<h2>Master Config Property</h2>

      <div class="wal-criteria-row col-8">
        <div class="wal-criteria-item">
          <label for="regionName" class="margin-left">Region: </label>
            <p-select id ="regionName" [options]="envRegions" [(ngModel)]="envRegionBaseUrl" [filter]="true" 
                (onChange)="onChangeRegion($event)"
                placeholder="Enviromental Region:" [editable]="false"  [style]="{ width: '100%' }">
            </p-select>
        </div>

        <div class="wal-criteria-item">
          <label for="propertyScope" class="margin-left">Property Scope: </label>
            <p-select id ="propertyScope" [options]="propertyScopes" [(ngModel)]="selectedPropertyScope" [filter]="true" 
                placeholder="Property Scope:" [editable]="false" [style]="{ width: '100%' }">
            </p-select>
        </div>

        <div class="wal-criteria-item">
          <label for="propertyType" class="margin-left">Property Type: </label>
            <p-select id ="propertyType" [options]="propertyTypes" [(ngModel)]="selectedPropertyType" [filter]="false" 
                placeholder="Property Type:" [editable]="false" [style]="{ width: '100%' }">
            </p-select>
        </div>

        <div class="wal-criteria-item">
            <label for="propertyName" class="margin-left">Property Name: </label>
            <input pInputText id="propertyName" [(ngModel)]="selectedPropertyName" placeholder="Property Name:" 
                [style]="{ width: '100%' }"/> 
        </div>

        <div class="wal-criteria-item wal-criteria-actions">
            <p-button type="submit" label="Search" 
                styleClass="p-button-success wal-success p-button-raised p-button-rounded margin-left" 
                (click)="onSearchClick($event)">
            </p-button>
            <p-button type="button" label="Clear" 
                styleClass="p-button-primary wal-primary p-button-raised p-button-rounded margin-left" 
                (click)="onClearClick($event)">
            </p-button>
        </div>
      </div>


<div class="grid w-full">
    <div class="col-11">

        <p-table #dt [columns]="cols" [value]="configProperties" selectionMode="single" 
            [(selection)]="selectedConfigProperty" class="wal-table"

                    [lazy]="true" [loading]="loading" (onLazyLoad)="loadConfigPropertiesLazy($event)" 
                    [totalRecords]="totalRecords"
                    [showCurrentPageReport]="false" dataKey="configPropertyId"
                    [scrollable]="true"  [virtualScroll]="false" [virtualScrollItemSize]="15"

            sortMode="multiple" (onRowSelect)="onRowSelect($event)" [paginator]="true" [rows]="15" >
          <ng-template pTemplate="caption">
              List of Config Properties
          </ng-template>
          <ng-template pTemplate="header" let-columns>
              <tr>
                    @for (col of columns; track col.field) {
                        <th [pSortableColumn]="col.field"
                            [style.display]="col.display"
                            [style.width]="col.width">
                            {{ col.header }}
                            <p-sortIcon [field]="col.field"></p-sortIcon>
                        </th>
                    }
            </tr>
<!-- 
            <tr>
                    @for (col of columns; track col.field) {
                        <th [style.width]="col.width" [style.display]="col.display">
                            @switch (col.field) {
                                @case ('propertyName') {
                                    <input pInputText type="text" [style.width]="'100%'"
                                        (input)="dt.filter(($any($event.target)).value, col.field, 'contains')"
                                    />
                                }
                                @case ('propertyType') {
                                    <input pInputText type="text" [style.width]="'100%'"
                                        (input)="dt.filter(($any($event.target)).value, col.field, 'contains')"
                                    />
                                }
                                @default {
                                }
                            }
                        </th>
                    }                
            </tr>  
 -->
        </ng-template>
          <ng-template pTemplate="body" let-rowData let-columns="columns">
              <tr [pSelectableRow]="rowData">
                        @for (col of columns; track col.field) {
                            <td [style.width]="col.width" [style.display]="col.display">
                                {{ rowData[col.field] }}
                            </td>
                        }
              </tr>
          </ng-template>

          <ng-template pTemplate="summary" let-rowData>
                <div style="text-align:left">
                    <div class="ui-helper-clearfix">
                        @if(isSubmitShown) {
                            <p-button label="Add" (click)="showDialogToAdd()" 
                                styleClass="p-button-info wal-info p-button-raised p-button-rounded margin-left">
                            </p-button> 
                        }
                    </div>
                </div>
          </ng-template> 

        </p-table> 
      
    </div>
</div>

<p-confirmDialog class="lf-confirm-dialog" appendTo="body"></p-confirmDialog>

<p-dialog appendTo="body" header="Config Property Details" [(visible)]="displayDialog" [focusOnShow]="false" 
        [responsive]="true" styleClass="wal-dialog"
        showEffect="fade" [modal]="true"  [style]="{width: '50%'}">
    <div *ngIf="configProperty">

        <p-card header="Master Config Property Details" subheader="" styleClass="ui-card-light" >

            <div class="grid">

                <div class="col-6">
                    
                    <div class="field grid">
                        <div class="col-2"></div>
                        <label for="configPropertyId" class="col-fixed label" style="width: 15em">Config Property Id:</label>
                        <div class="col-2">
                            <input pInputText id="configPropertyId" [(ngModel)]="configProperty.configPropertyId" autofocus readonly  style="width: 10em"/>
                        </div>
                    </div>

                </div>

                <div class="col-6">

                    <div class="field grid">
                        <div class="col-1"></div>
                        <label for="Enabled" class="col-fixed label" style="width: 15em">Enabled:</label>
                        <div class="col-2">
                            <p-checkbox [(ngModel)]="configProperty.enabled" id="enabled" [binary]="true"></p-checkbox>
                        </div>
                    </div>
        
                </div>

            </div>

            <div class="field grid">
                <div class="col-1"></div>
                    <label for="propertyName" class="col-fixed label" style="width: 15em">Property Name:</label>
                <div class="col-8"> 
                    <textarea [rows]="1" [cols]="30" pTextarea [autoResize]="autoResize" id="propertyName" 
                        [(ngModel)]="configProperty.propertyName" style="width: 100%"></textarea>
                </div>
            </div>

            <div class="field grid">
                <div class="col-1"></div>
                    <label for="propertyDescription" class="col-fixed label" style="width: 15em">Property Description:</label>
                <div class="col-8">
                    <textarea [rows]="1" [cols]="30" pTextarea [autoResize]="autoResize" id="propertyDescription" 
                        [(ngModel)]="configProperty.propertyDescription" style="width: 100%"></textarea>
                </div>
            </div>

            <div class="grid">

                <div class="col-6">
                    
                    <div class="field grid">
                        <div class="col-2"></div>
                        <label for="propertyScope" class="col-fixed label" style="width: 15em">Property Scope:</label>
                        <div class="col-4">
                            <p-select id ="propertyScope" [options]="propertyScopes" [(ngModel)]="configProperty.propertyScope" [filter]="false" 
                                placeholder="Select scope" [editable]="false"></p-select>
                        </div>
                    </div>
                </div>

                <div class="col-6">

                    <div class="field grid">
                        <div class="col-1"></div>
                        <label for="propertyType" class="col-fixed label" style="width: 15em">Property Type:</label>
                        <div class="col-4">
                            <p-select id ="propertyType" [options]="propertyTypes" [(ngModel)]="configProperty.propertyType" [filter]="false" 
                                placeholder="Select type" [editable]="false"></p-select>
                        </div>
                    </div>
                </div>

            </div>
        

            <div class="field grid">
                <div class="col-1"></div>
                    <label for="defaultValue" class="col-fixed label" style="width: 15em">Default Value:</label>
                <div class="col-8">
                    <textarea [rows]="1" [cols]="30" pTextarea [autoResize]="autoResize" id="propertyValue" 
                        [(ngModel)]="configProperty.defaultValue" style="width: 100%"></textarea>
                </div>
            </div>

            <div class="grid">

                <div class="col-6">

                    <div class="field grid">
                        <div class="col-2"></div>
                        <label for="createDate" class="col-fixed label" style="width: 15em">Create Date:</label>
                        <div class="col-4">
                            <input pInputText id="createDate" [(ngModel)]="configProperty.createDate" readonly style="width: 12em"/>
                        </div>
                    </div>
                            
                </div>

                <div class="col-6">

                    <div class="field grid">
                        <div class="col-1"></div>
                        <label for="lastUpdateDate" class="col-fixed label" style="width: 15em">Last Update Date:</label>
                        <div class="col-4">
                            <input pInputText id="lastUpdateDate" [(ngModel)]="configProperty.lastUpdateDate" readonly style="width: 12em"/>
                        </div>
                    </div>
        
                </div>

            </div>


    </p-card>

    </div>
    <ng-template #footer>
        <div class="footer-actions">
            <p-button type="button" label="Delete" styleClass="p-button-danger wal-danger p-button-raised p-button-rounded margin-left" (click)="delete()" *ngIf="isSubmitShown" ></p-button>
            <p-button type="button" label="Save" styleClass="p-button-success wal-success p-button-raised p-button-rounded margin-left" (click)="save()" *ngIf="isSubmitShown" ></p-button>
            <p-button type="button" label="Cancel" styleClass="p-button-primary wal-primary p-button-raised p-button-rounded margin-left" (click)="cancel()"></p-button>
        </div>
    </ng-template>

</p-dialog>
